module.exports = __webpack_public_path__ + "img/MC_ID_Capture.0bdbaf08.png";